
















































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import UpdateAccountRequest from '@/models/Accounts/Shared/UpdateAccountRequest';
import { LendingAccountModule } from '@/store/Accounts/LendingAccountModule';

@Component({ name: 'DetailsEditDialog' })
export default class extends SaascadaVueDialog {

    request: UpdateAccountRequest = new UpdateAccountRequest();
    dateAsString: string = '';
    todaysDateAsString: string = new Date().toISOString().split('T')[0];

    @Watch('dialog')
    onDialogChanged(val: boolean) {
        if (val) {
            this.request = new UpdateAccountRequest();
            this.request.name = LendingAccountModule.lendingAccount.name;
            this.todaysDateAsString = new Date().toISOString().split('T')[0];
            this.dateAsString = LendingAccountModule.lendingAccount.reviewDateUtc ? new Date(LendingAccountModule.lendingAccount.reviewDateUtc).toISOString().split('T')[0] : '';
        }
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;
            this.request.reviewDateUtc = new Date(this.dateAsString + "T00:00:00Z");
            await LendingAccountModule.editLendingAccount(this.request);
        }
    }

}
